<template>
  <div class="space-y-6">
    <FormGroup
      label="Rate specific criteria (Optional)"
      :help="helperText"
    >
      <div
        v-if="Object.keys(ratingDetails).length > 0"
        class="mb-6"
      >
        <div class="space-y-3 p-4 bg-gray-50 rounded-lg">
          <div
            v-for="(rating, key) in ratingDetails"
            :key="key"
            class="flex items-center justify-between p-2 bg-white rounded border"
          >
            <span class="font-medium text-gray-700">
              {{ RATING_CRITERIA.find((c) => c.value === key)?.label }}
            </span>
            <div class="flex items-center gap-4">
              <div class="flex items-center gap-2">
                <RatingStars
                  :rating="rating"
                  size="sm"
                />
                <span class="text-sm text-gray-600">{{ rating }}/5</span>
              </div>
              <Button
                color="red"
                variant="solid"
                size="sm"
                class="rounded-full w-8 h-8 flex items-center justify-center p-0 bg-red-50 hover:bg-red-100 transition-colors"
                @click="removeCriteria(key.toString())"
              >
                <Icon
                  name="i-heroicons-minus"
                  class="w-5 h-5 text-red-600"
                />
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="availableCriteria.length > 0"
        class="flex items-end gap-4"
      >
        <Select
          v-model="selectedCriteria"
          :options="availableCriteria"
          placeholder="Select criteria"
          class="w-full"
        />
        <div class="flex items-center gap-3">
          <StarSelector
            v-model="criteriaRating"
            size="sm"
          />
          <Button
            color="primary"
            variant="solid"
            size="sm"
            :disabled="!selectedCriteria || !criteriaRating"
            class="rounded-full w-8 h-8 flex items-center justify-center p-0 hover:bg-primary-600 transition-colors"
            @click="addCriteria"
          >
            <Icon
              name="i-heroicons-plus"
              class="w-5 h-5"
            />
          </Button>
        </div>
      </div>
      <div
        v-else
        class="text-sm text-gray-500 italic"
      >
        All rating criteria have been added
      </div>
    </FormGroup>
  </div>
</template>

<script setup lang="ts">
import StarSelector from '~/components/common/StarSelector.vue'

const RATING_CRITERIA = [
  { value: 'compensation_benefits', label: 'Compensation / Benefits' },
  { value: 'culture', label: 'Culture' },
  { value: 'management', label: 'Management' },
  { value: 'work_life_balance', label: 'Work / Life Balance' },
  { value: 'security_advancement', label: 'Security / Advancement' }
]
const props = defineProps<{
  ratingDetails: Record<string, number>
  helperText?: string
}>()
const emit = defineEmits<{
  'update:ratingDetails': [value: Record<string, number>]
}>()
const selectedCriteria = ref('')
const criteriaRating = ref(0)
const availableCriteria = computed(() => {
  return RATING_CRITERIA.filter(
    criteria => !props.ratingDetails[criteria.value]
  )
})
const addCriteria = () => {
  if (!selectedCriteria.value || !criteriaRating.value) return
  const updatedRatings = { ...props.ratingDetails }
  updatedRatings[selectedCriteria.value] = criteriaRating.value
  emit('update:ratingDetails', updatedRatings)
  selectedCriteria.value = ''
  criteriaRating.value = 0
}
const removeCriteria = (key: string) => {
  const updatedRatings = { ...props.ratingDetails }
  delete updatedRatings[key]
  emit('update:ratingDetails', updatedRatings)
}
</script>
